// Convierte un nombre de catálogo (a menudo en MAYÚSCULAS y con abreviaturas
// como "1M PERFIL") en un nombre presentable para la ruleta de premios --
// el admin arma la ruleta eligiendo un producto, no escribiendo el nombre a
// mano, así que este es el que decide cómo se ve por defecto.
const BRAND_MAP = [
  [/crunchy\s*roll/i, "Crunchyroll"],
  [/hbo\s*max/i, "HBO Max"],
  [/netflix/i, "Netflix"],
  [/disney/i, "Disney+"],
  [/spotify/i, "Spotify"],
  [/universal\s*\+?/i, "Universal+"],
  [/vix\s*plus|^vix\b/i, "ViX+"],
  [/prime\s*video/i, "Prime Video"],
  [/paramount/i, "Paramount+"],
  [/fox\s*one/i, "FOX One"],
  [/canva/i, "Canva"],
  [/duolingo/i, "Duolingo"],
  [/gemini/i, "Gemini"],
  [/iptv/i, "IPTV"],
  [/apple\s*tv/i, "Apple TV+"],
  [/office\s*365/i, "Office 365"],
  [/acta de nacimiento/i, "Acta de Nacimiento"],
  [/acta de matrimonio/i, "Acta de Matrimonio"],
  [/acta de defunci/i, "Acta de Defunción"],
  [/acta de divorcio/i, "Acta de Divorcio"],
  [/\bcsf\b/i, "Constancia Fiscal (CSF)"],
];

const titleCase = (s) => s.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

export default function prettyProductName(raw) {
  if (!raw) return "";
  const upper = raw.toUpperCase();
  const brand = (BRAND_MAP.find(([re]) => re.test(raw)) || [])[1];
  const base = brand || titleCase(raw.replace(/\s+/g, " ").trim());

  const monthMatch = upper.match(/\b(\d+)\s*M\b/);
  const months = monthMatch ? Number(monthMatch[1]) : null;
  const completa = /COMPLETA/.test(upper);
  const perfil = !completa && /PERFIL/.test(upper);
  const privado = /\bPRIV/.test(upper);

  const parts = [base];
  if (months) parts.push(months === 1 ? "1 Mes" : `${months} Meses`);
  if (completa) parts.push("Cuenta Completa");
  else if (perfil) parts.push("Perfil");
  if (privado) parts.push("Privada");
  return parts.join(" · ");
}
